import * as Api from '../utils/Api';
import { all, call, put } from 'redux-saga/effects';
import { types as memberTypes } from '../reducers/organizationMembers';
import { types as billingTypes } from '../reducers/billing';

export function* toggleOwnership(action) {
  const { organizationUuid, userUuid, role } = action;

  if (!organizationUuid || !userUuid || !role) {
    throw new Error('Missing required parameters for toggling ownership');
  }

  const response = yield call(
    Api.put,
    `organizations/${organizationUuid}/members/${userUuid}`,
    { role }
  );
  const data = response.data;

  if (!response.success) {
    yield put({
      type: memberTypes.OWNERSHIP_FAILURE,
      error: data ? data.error_message : 'Unknown error',
    });
  } else {
    yield put({
      type: memberTypes.OWNERSHIP_SUCCESS,
    });
    yield fetchOrganizationMembers({ organizationUuid });
  }
}

export function* fetchOrganizationMembers(action) {
  const { organizationUuid } = action;

  if (!organizationUuid) {
    throw new Error('Missing required parameters for fetching members');
  }

  yield call(batchFetchOrganizationMembers, organizationUuid);
}

export function* batchFetchOrganizationMembers(organizationUuid) {
  let members = [];
  let response = undefined;
  let nextPageUrl = undefined;

  do {
    response = yield call(
      Api.get,
      nextPageUrl || `organizations/${organizationUuid}/members`
    );

    if (!response.success) {
      yield put({
        type: memberTypes.MEMBERS_FAILURE,
        error: response.data?.error_message ?? 'Unknown error',
      });

      return;
    }

    const { next_page_url, data } = response.data;
    members = members.concat(data);
    nextPageUrl = next_page_url;
  } while (nextPageUrl);

  yield put({
    type: memberTypes.MEMBERS_SUCCESS,
    organizationUuid,
    members,
  });
}

export function* fetchMembershipData(action) {
  const { organizationUuid } = action;
  if (!organizationUuid) {
    throw new Error('Missing required parameters for fetching membership data');
  }

  yield all([
    put({
      type: memberTypes.MEMBERS_REQUEST,
      organizationUuid,
    }),
    put({
      type: memberTypes.MISSING_MEMBERS_REQUEST,
      organizationUuid,
    }),
    put({
      type: billingTypes.GET_BILLING_INFO_REQUEST,
      organizationUUID: organizationUuid,
    }),
  ]);
}
